import React from 'react';
import { useSelector } from 'react-redux';

import CloseIcon from '@components/CloseIcon';

const BottomPopup = ({ onActionClick, showUnSelectAll }) => {
	const selectedCRMProducts = useSelector((state) => state.crmCommonStore.selectedCRMProducts);

	const getActionForSelectedStyles = () => {
		const hasRejected = selectedCRMProducts.some((style) => style.designClosedAt);
		const hasNonRejected = selectedCRMProducts.some((style) => !style.designClosedAt);

		if (hasRejected && hasNonRejected) {
			return 'error';
		}

		if (selectedCRMProducts.every((style) => style.designClosedAt)) {
			return 'restore';
		}

		if (!hasRejected) {
			return 'close';
		}

		return null;
	};

	return (
		<div className={'design-count-section bg-white collection-details-design-count shadow-8dp'}>
			<div className="count-info d-flex justify-content-between align-items-center">
				{getActionForSelectedStyles() === 'error' ? (
					<div className="alert-text d-flex align-items-center">
						<img src={`${process.env.PUBLIC_URL}/icons/overdue-icon.svg`} alt="add" />
						<p className="regular-14  pl-2">You have to select styles from similar status</p>
					</div>
				) : (
					<>
						<div className="design-count">
							<p className="regular-14">{selectedCRMProducts.length}</p>
						</div>

						<div className="buttons d-flex align-items-center align-self-center">
							<>
								{!showUnSelectAll && (
									<>
										<button
											className="button text size36"
											onClick={() => onActionClick('SELECT_ALL')}
										>
											<span className="ml-1">Select All</span>
										</button>
										<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
											|
										</span>
									</>
								)}
								{showUnSelectAll && (
									<>
										<button
											className="button text size36"
											onClick={() => onActionClick('UN_SELECT_ALL')}
										>
											<span className="ml-1">Unselect All</span>
										</button>
										<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
											|
										</span>
									</>
								)}

								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('EOD')}
									>
										<img
											src={`${process.env.PUBLIC_URL}/icons/add-round.svg`}
											alt="add"
										/>
										<span className="ml-1">EOD</span>
									</button>

									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
								</>
							</>

							<>
								{getActionForSelectedStyles() === 'restore' && (
									<button
										className="button text size36"
										onClick={() => onActionClick('RESTORE_STYLE')}
									>
										<span className="ml-1">Restore Style</span>
									</button>
								)}
								{getActionForSelectedStyles() === 'close' && (
									<button
										className="button text size36"
										onClick={() => onActionClick('CLOSE_STORE')}
									>
										<span className="ml-1">Close Style</span>
									</button>
								)}
							</>
						</div>
					</>
				)}
				<CloseIcon onClick={() => onActionClick('CLEAR')} />
			</div>
		</div>
	);
};

export default BottomPopup;
